import { render, staticRenderFns } from "./My_Tags.vue?vue&type=template&id=317ca795&scoped=true"
import script from "./My_Tags.vue?vue&type=script&lang=js"
export * from "./My_Tags.vue?vue&type=script&lang=js"
import style0 from "./My_Tags.vue?vue&type=style&index=0&id=317ca795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317ca795",
  null
  
)

export default component.exports